import React,{useState ,useEffect } from 'react';
import styled from 'styled-components';
import {TaxInvoice} from './Viewer';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f9f9f9;

`;

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #333;
`;

const SubTitle = styled.h3`
  font-size: 18px;
  color: #666;
`;

const InfoBox = styled.div`
  margin-bottom: 20px;
  background-color: #f1f1f1;
  padding: 20px;
  border-radius: 10px;
  display:flex;
  justify-content:space-between;
`;

const SampleButton = styled.button`
  background-color: #3498db;
  color: white;
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #2980b9;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;

  th, td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
`;
const UserCorptax = () => {
    

    
    return (
        <Wrapper>
           <DataTable/>
           </Wrapper>
    );
};

const DataTable = () => {
    const [corptaxData, setCorptaxData] = useState([]);
    // 데이터를 가져오는 useEffect
 useEffect(() => {
   const fetchCorptaxData = async () => {
     try {
       const response = await fetch('/Acution/corptax-data');  // 백엔드 엔드포인트
       if (response.ok) {
         const data = await response.json();
         setCorptaxData(data);
       } else {
         console.error('데이터를 가져오는 데 실패했습니다.');
       }
     } catch (error) {
       console.error('기업세 데이터를 가져오는 중 오류 발생:', error);
     }
   };

   fetchCorptaxData();
 }, []);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const openViewer = () => {
      setIsViewerOpen(true);
    };
  
    const closeViewer = () => {
      setIsViewerOpen(false);
    };
 
  return (
    <Container>
      <Title>사업자회원</Title>
      <InfoBox>
        <section>
          <strong>공급받는자 정보</strong>
          <p style={{fontSize:'8pt'}}>회사명: (주)언체인</p>
          <p style={{fontSize:'8pt'}}>사업자번호: 523-81-03358</p>
          <p style={{fontSize:'8pt'}}>주소: 경기도 남양주시 순화궁로 249, M동 13층 1330호(별내동, 별내역파라곤스퀘어)</p>
          <div style={{fontSize:'8pt'}}>업태: 정보통신업 , 도소매업</div>
          <div style={{fontSize:'8pt'}}>종목:소프트웨어 및 솔루션 개발 전자상거래</div>
        </section>
          <SampleButton onClick={openViewer}>샘플보기</SampleButton>
      </InfoBox>
      <StyledTable>
        <thead>
          <tr>
            <th>공급월</th>
            <th>공급가액</th>
            <th>회사명</th>
            <th>사업자번호</th>
          </tr>
        </thead>
        <tbody>
          {corptaxData.map((row, index) => (
            <tr key={index}>
              <td>{row.supply_month}</td>
              <td>{row.supply_amount}</td>
              <td>{row.company_name}</td>
              <td>{row.business_number}</td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
      {isViewerOpen && <TaxInvoice onClose={closeViewer} />}
    </Container>
  );
};
export default UserCorptax;